import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { InputAdornment } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import mepcoLogo from '../../../images/mepcoLogo.png';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import { useNavigate, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { forgotpasswordSchema } from "../../../schemas/forgot";
import './forgotpassword.scss';
import { cfpBaseUrl } from '../../../network/urls';
import CircularProgress from '@mui/material/CircularProgress';
import eOpsLogo from '../../../images/eops.png'


const initialValues = {
  Username: "",
};
const Forgotpassword = () => {
  const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);

  const Navigate = useNavigate();
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: forgotpasswordSchema,
      onSubmit: async (values, action) => {
        setIsLoadingSpinner(true);
        let USERNAME = values.Username
        var formdata = new FormData();
        formdata.append("userId", values.Username);
        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "customerFaciliationPortal/forgotPasswordOTP", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              let otpval = result.otp
              // console.log(otpval,'ooootttttppp')
              setIsLoadingSpinner(false);
              Navigate('/otp-verification', { state: { otpval, USERNAME } })
              // console.log(otp);
            }
            else {
              setIsLoadingSpinner(false);
              // console.log(result.message)
            }
          })
          .catch(error => {
            setIsLoadingSpinner(false);
            console.log(error)
          });
      },
    });
  return (
    <>
      <Grid className='background'>

        <form className='forgotpasswordform'>
          <img src={eOpsLogo} alt="eOps" className='logo' />
          <Box className='form-fields'>
            <TextField
              type='text'
              margin="normal"
              className='textfield'
              required
              fullWidth
              value={values.Username}
              name="Username"
              onChange={handleChange}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <EmailIcon className='icon' />
                  </InputAdornment>
                )
              }}
              id="Username"
              label=""
              placeholder='Username'
              autoComplete=""
              size='small'
            />
            {errors.Username && touched.Username ? (
              <p className="form-error">{errors.Username}</p>
            ) : null}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className='form-button'
              onClick={handleSubmit}
              disabled={isLoadingSpinner}
              sx={{ textTransform: 'capitalize' }}
            >
              {isLoadingSpinner ? (
                <Box sx={{ display: 'flex' }}>
                  <CircularProgress color='inherit' size='1.7rem' />
                </Box>
              ) : (
                'Verify User'
              )}
            </Button>
           
            < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
            <Grid className='powered-by'>
              <Box className='form-bottom-link'>
                <Link to='/'  >
                  Sign in
                </Link>
              </Box>
              <Grid className='logos'>
                <img className='usaid' src={usLogo} alt="" />
                <img className='pitc' src={pitcLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
        </form>
      </Grid>
    </>
  );
}
export default Forgotpassword;
